<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header
      [header]="data().title"
      [imageUrl]="data().avatar_url"
      [separator]="false"
    />
  </ng-container>

  <ng-container body>
    <email-margin [height]="18" />
    <email-text [contents]="data().p1" presetName="paragraph" />
    <email-margin [height]="18" />
    <email-text [contents]="data().p2_html" color="light" className="web-rt-contains-link" />
    <email-margin [height]="28" />
    <hr />
    <email-margin [height]="28" />
    <email-text [contents]="data().p3" presetName="paragraph" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data().footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data().footer.label"
      [href]="data().footer.href"
      [target]="data().footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
